const windowTopUTL = () => window.scrollTo(0, 0);
export default windowTopUTL;
